import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { ProjetoTramitacao } from '../../../models/projeto-tramitacao.model';
import { ProjetoTramitacaoService } from '../../../services/projeto-tramitacao.service';
import { environment } from 'src/environments/environment';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';

@Component({
  selector: 'app-projeto-tramitacao-edit',
  templateUrl: './projeto-tramitacao-edit.component.html',
  styleUrls: ['./projeto-tramitacao-edit.component.scss'],
})
export class ProjetoTramitacaoEditComponent
  extends BaseFormComponent<ProjetoTramitacao>
  implements OnInit
{
  idProjeto: number;
  modalRef?: BsModalRef;
  files: { file: File | null }[] = [{ file: null }];
  routing: { action_id?: number; routing_description?: string };
  audit: AtualizacoesAudit;
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;
  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    private myService: ProjetoTramitacaoService,
    private projetoService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private modalService: BsModalService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      process_analyst: new FormControl(null),
      process_stat_id: new FormControl(null, Validators.required),
      process_dt_conclusion: new FormControl(null),
      project_selected: new FormControl(null, Validators.required),
      process_sub_stat_name: new FormControl({ value: null, disabled: true }),
      process_control_name: new FormControl({ value: null, disabled: true }),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      if (!this.entity?.can_save) this.form.disable();

      this.audit = { pp_id: this.entity.id };
    }
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }

  getDataCreate(): FormData {
    const data = { ...this.form.value } as ProjetoTramitacao;

    if (this.routing?.action_id) {
      data.action_id = this.routing?.action_id;
      data.routing_description = this.routing?.routing_description;
    }

    const formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (data?.process_dt_conclusion && !formatoDataRegex.test(data?.process_dt_conclusion)) {
      data.process_dt_conclusion = formatDate(data?.process_dt_conclusion, 'DD/MM/YYYY');
    }

    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(
          key,
          data[key] !== null && data[key] !== undefined ? data[key] : ''
        );
      }
    }

    this.files.forEach((fileObj, index) => {
      if (fileObj.file) {
        formData.append(
          `routing_files[${index}]`,
          fileObj.file,
          fileObj.file.name
        );
      }
    });

    return formData;
  }

  update(saveForm: boolean = false): void {
    if (this.form.valid && this.entity?.id) {
      if (saveForm) {
        this.routing = { action_id: null, routing_description: '' };
        this.files = [{ file: null }];
      } else {
        this.closeModal();
      }
      this.loading();
      this.addSub(
        this.myService
          .updateDocumento(this.getDataCreate(), this.entity.id)
          .subscribe({
            next: () => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.entityRefresh();
              EventSharedService.get('auditRefresh').emit();
            },
            error: (error) => {
              this.msgError(error.error.message);
              this.loaded();
            },
          })
      );
    } else {
      this.markAsDirty();
    }
  }

  entityRefresh() {
    this.addSub(
      this.myService.getById(this.entity?.id).subscribe({
        next: (res) => {
          this.entity = res;
          this.initForm();
          this.loaded();
        },
        error: (erro) => {
          this.msgError(erro?.error?.message);
          this.loaded();
        },
      })
    );
  }

  openModal(action_id: number) {
    this.routing = { action_id: action_id, routing_description: '' };
    this.files = [{ file: null }];
    this.modalRef = this.modalService.show(this.modal, {
      class: 'modal-xl modal-top',
    });
  }

  closeModal() {
    this.modalRef?.hide();
  }

  onFileSelected(event: any, index: number): void {
    const file = event.target.files[0];
    this.files[index].file = file;
  }

  addFileField(): void {
    this.files.push({ file: null });
  }

  removeFileField(index: number): void {
    this.files.splice(index, 1);
  }

  download(data) {
    this.loading();
    this.addSub(
      this.myService.download(data.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get(
            'content-disposition'
          );
          const fileName = contentDispositionHeader
            ? this.myService.extractFilename(contentDispositionHeader)
            : data?.name;
          const blob = new Blob([res.body], {
            type: 'application/octet-stream',
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = 'Arquivo não encontrado.';
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.entity?.id).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.entity?.id && this.entity.can_clone) {
      const obj = {
        clone_id: this.entity?.id,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.entity?.id}`;
    this.loaded();
    window.open(url, '_blank');
  }
}